// localStorage keys
const KEYS = {
  TOKEN: 'flock_test_token',
  REFRESH_TOKEN: 'flock_test_refresh_token',
  USER_ID: 'flock_test_user_id',
  CURRENT_ORG_ID: 'flock_test_current_org_id',
  USER_INFO: 'flock_test_user_info',
  SUBSCRIPTION_MODE: 'subscription_test_mode',
};

// Token management
export const getToken = () => localStorage.getItem(KEYS.TOKEN);
export const setToken = (token) => localStorage.setItem(KEYS.TOKEN, token);

export const getRefreshToken = () => localStorage.getItem(KEYS.REFRESH_TOKEN);
export const setRefreshToken = (token) => localStorage.setItem(KEYS.REFRESH_TOKEN, token);

// User ID
export const getUserId = () => localStorage.getItem(KEYS.USER_ID);
export const setUserId = (userId) => localStorage.setItem(KEYS.USER_ID, userId);

// Current organization
export const getCurrentOrgId = () => localStorage.getItem(KEYS.CURRENT_ORG_ID);
export const setCurrentOrgId = (orgId) => localStorage.setItem(KEYS.CURRENT_ORG_ID, orgId);

// User info (full object)
export const getUserInfo = () => {
  const info = localStorage.getItem(KEYS.USER_INFO);
  return info ? JSON.parse(info) : null;
};
export const setUserInfo = (userInfo) => {
  localStorage.setItem(KEYS.USER_INFO, JSON.stringify(userInfo));
};

// Clear all auth data
export const clearAuth = () => {
  Object.values(KEYS).forEach(key => localStorage.removeItem(key));
};

// Check if authenticated
export const isAuthenticated = () => {
  const token = getToken();
  return !!token;
};

// Subscription test mode (simulation vs stripe)
export const getSubscriptionMode = () => {
  const mode = localStorage.getItem(KEYS.SUBSCRIPTION_MODE);
  return mode === 'stripe' ? 'stripe' : 'simulation'; // Default to simulation
};
export const setSubscriptionMode = (mode) => {
  localStorage.setItem(KEYS.SUBSCRIPTION_MODE, mode);
};
export const isStripeMode = () => getSubscriptionMode() === 'stripe';
export const isSimulationMode = () => getSubscriptionMode() === 'simulation';
